import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./anchor.scss";
import BaseAnchor from "./BaseAnchor";

export const isExternal = url => /^(http|tel|mailto|\/\/)/.test(url || "");

const Anchor = ({ to, onClick, children, className, ...props }) => {
  const classes = classnames("anchor", className);

  return (
    <BaseAnchor className={classes} to={to} onClick={onClick} {...props}>
      {children}
    </BaseAnchor>
  );
};

Anchor.propTypes = {
  /**
   * The link destination
   */
  to: PropTypes.string,
  /**
   * Function triggered on click of link
   */
  onClick: PropTypes.func,
  /**
   * Child elements
   */
  children: PropTypes.string.isRequired,
  /**
   * Additional CSS class names
   */
  className: PropTypes.string,
};

export default Anchor;
